import { EmptyCheckedPlaceholder, importDeleteMapping } from '../models/Import';
// export function getEnvVar<T extends string>(name: EnvVars, reload: boolean, shutdownOnFail: true): T
// export function getEnvVar<T extends string>(name: EnvVars, reload?: boolean): T | undefined
// /**
//  * @param name name of the env var
//  * @param reload force reload from file
//  * @param shutdownOnFail shuts down when not found
//  * @returns
//  */
// export function getEnvVar<T extends string>(name: EnvVars, reload?: boolean, shutdownOnFail?: boolean) {
//   if (reload) {
//     config({ override: true, quiet: true })
//   }
//   const variable = process.env[name]
//   if (!variable && shutdownOnFail) {
//     console.warn(`Required env var ${name} not set`)
//     console.log('Shutting down...')
//     process.exit()
//   }
//   return variable as T
// }
export const valueIsEmpty = (value) => value !== 0 && !value;
/**
 * Ensures a string value without converting e.g. undefined to "undefined"
 * Should be used instead of String(str), not instead of str.toString()
 */
// export const toSafeString = (value: any) => (!value && value !== 0 ? '' : String(value))
// export const toSafeString = (value: any) => value?.toString() ?? ''
export const toSafeString = (value) => (!value && value !== 0 ? '' : typeof value === 'string' ? value : String(value));
export const toSafeNumber = (num) => (num === undefined ? null : toNumber(num));
/**
 * Converts to lower case string and trims. Converts line breaks to '-'
 * Use to compare strings
 * @param name
 * @returns
 */
export const toComparable = (name) => name?.toString().trim().toLowerCase().replace(/\r?\n/g, '-') ?? '';
/**
 * Like toComparable, but doesn't attempt to convert line breaks
 * @param name
 * @returns
 */
export const toKey = (name) => toRawKey(name)?.toLowerCase() ?? '';
export const toComparableLight = toKey;
export const toCamelCasedKey = (name) => {
    const rawKey = toRawKey(name);
    if (rawKey) {
        return toCamelCase(rawKey);
    }
};
const toRawKey = (name) => name?.toString().trim();
export const toSlug = (value) => value
    .normalize('NFKD')
    .replace(/[åäæ]/g, 'a')
    .replace(/[öø]/g, 'o')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’]/g, '')
    .split(/[^a-zA-Z0-9-]+/)
    .filter(Boolean)
    .map((part, index) => {
    const lower = part.toLowerCase();
    if (index === 0) {
        return lower;
    }
    return lower.charAt(0).toUpperCase() + lower.slice(1);
})
    .join('');
export const toCamelCase = (value) => value
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .normalize('NFKD')
    .replace(/[åäæ]/g, 'a')
    .replace(/[öø]/g, 'o')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’]/g, '')
    .split(/[^a-z0-9]+/i)
    .map((part, index) => {
    if (part) {
        const lower = part.toLowerCase();
        return index === 0 ? lower : lower.charAt(0).toUpperCase() + lower.slice(1);
    }
})
    .join('');
export const areComparable = (str1, str2) => toComparable(str1) === toComparable(str2);
export const areComparableLight = (str1, str2) => toComparableLight(str1) === toComparableLight(str2);
export const camelCaseToTerm = (camelCaseName) => {
    try {
        if (!camelCaseName) {
            return '';
        }
        return (camelCaseName.slice(0, 1)?.toUpperCase() +
            camelCaseName
                .slice(1)
                .replace(/([a-z])([A-Z])/g, `$1 $2`)
                .replace(/([A-Z](?=[a-z]))/g, (g1) => (g1 + '')?.toLowerCase()));
    }
    catch (err) {
        console.log(err, typeof camelCaseName);
    }
    return '';
};
export const toTitle = (str) => capitalize(camelCaseToTerm(str));
export const clone = (obj) => JSON.parse(JSON.stringify(obj));
export const capitalize = (str) => toSafeString(str).substring(0, 1).toUpperCase() + toSafeString(str).substring(1);
export const getInnerProperty = (obj, keys) => {
    try {
        let value = obj;
        for (let i = 0; value !== undefined && i < keys.length; i++) {
            value = value[keys[i]];
        }
        return value;
    }
    catch (err) {
        // console.log('could not find inner property', keys.join(' > '))
    }
};
export const setEnsuredInnerValue = (obj, keyPath, value) => {
    keyPath.forEach((key, i) => {
        if (i === keyPath.length - 1) {
            obj[key] = value;
        }
        else {
            if (!obj[key]) {
                obj[key] = {};
            }
            obj = obj[key];
        }
    });
};
/**
 * Sorts a category array by parentId
 */
export const getHierarchicallySortedCategories = (categories) => {
    categories?.sort((a, b) => ('name' in a && 'name' in b ? toComparableLight(a.name)?.localeCompare(toComparableLight(b.name)) || 0 : 0));
    return categories && categories?.length > 1 ? recursiveSort(categories) : categories;
};
/**
 * Helper function for sortHierarchically
 */
const recursiveSort = (objects, parentId) => objects?.reduce((acc, object) => {
    if (parentId ? object.parentId == parentId : !object.parentId) {
        acc = [...acc, object, ...recursiveSort(objects, object.id)];
    }
    return acc;
}, []) || [];
export const baseTaxonomicSort = (a, b) => a.defaultName.localeCompare(b.defaultName);
export const simplifiedTaxonomicSort = (a, b, descending, locale = 'sv-SE', numericSorting) => {
    // return stringSort(a, b, ['name', 'defaultName'], descending, locale)
    const first = descending ? b : a;
    const second = descending ? a : b;
    if (numericSorting) {
        return toNumber(first.name || first.defaultName) - toNumber(second.name || second.defaultName);
    }
    return (first.name || first.defaultName)?.toString()?.localeCompare((second.name || second.defaultName)?.toString(), locale);
};
// export const findObjectByComparable = (object: RawTaxonomyObject | SimplifiedTaxonomyObject, defaultName: string) => {
//   return toComparable(object.defaultName) === toComparable(defaultName)
// }
export const getYoutubeId = (fullLink) => {
    if (fullLink) {
        try {
            const idFromQuery = new URL(fullLink).searchParams.get('v');
            const idFromParam = fullLink
                ?.split('/')
                .filter((part) => !!part)
                .slice(-1)
                .join('');
            return idFromQuery || idFromParam;
        }
        catch (err) {
            console.log(err);
        }
    }
};
export const getYoutubeLink = (id, includeQuerySettings = true) => {
    if (id) {
        const query = '?controls=1;mute=1;showinfo=0;autoplay=0';
        const embedLink = `https://www.youtube.com/embed/${id}`;
        return embedLink + (includeQuerySettings ? query : '');
    }
};
// export const sanitizeObjectProperties = (object?: { [key: string]: any }) => {
//   if (object && typeof object === 'object') {
//     // check both since null is of type object
//     Object.entries(object).forEach(([key, value]) => {
//       if (value === null || value === importDeleteMapping || value == FieldValue.delete()) {
//         object[key] = FieldValue.delete()
//       } else if (value === undefined) {
//         delete object[key]
//       } else if (value && typeof value === 'object') {
//         sanitizeObjectProperties(value)
//         if (!Object.keys(value).length) {
//           delete object[key]
//         }
//       }
//     })
//   }
// }
// export const sanitizeObject = (object?: { [key: string]: any }, changedKeys: string[] = []) => {
//   if (object && typeof object === 'object') {
//     // check both since null is of type object
//     Object.entries(object).forEach(([key, value]) => {
//       if (value === '\n' || !toSafeString(value).trim()) {
//         object[key] = FieldValue.delete()
//         changedKeys.push(key)
//       } else {
//         sanitizeObject(value, changedKeys)
//       }
//     })
//     return changedKeys
//   }
// }
/**
 * Removes empty inner objects and no-valued properties. Does not modify the original
 */
export const filterEmptyObjects = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    if (Array.isArray(obj) && obj.length) {
        return obj.map(filterEmptyObjects);
    }
    let filteredObjectHasProperties = false;
    const filteredObj = {};
    for (const [key, value] of Object.entries(obj)) {
        const filteredValue = filterEmptyObjects(value);
        if (filteredValue !== null && filteredValue !== undefined && filteredValue !== '') {
            filteredObj[key] = filteredValue;
            filteredObjectHasProperties = true;
        }
    }
    return filteredObjectHasProperties ? filteredObj : null;
};
export const sanitizeSpaces = (value) => value?.toString().replace(/\s/g, '');
export const sanitizeValue = (str) => {
    try {
        // return typeof str === 'string' ? str?.replace(/^(\s*(no|nej|nei|ingen|n\/a)\s*)$/i, '').trim() : str
        return str?.replace(/^(\s*(no|nej|nei|ingen)\s*)$/i, '').trim();
    }
    catch (err) {
        throw new Error();
    }
};
export const parseSanitizedNumber = (value) => {
    if (value === importDeleteMapping) {
        return value;
    }
    // return value ? toNumeric(value) : value
    if (value && value !== EmptyCheckedPlaceholder) {
        return toNumber(value);
    }
    return value;
};
export const toNumber = (value) => (typeof value === 'number' ? value : Number(value?.toString().replace(',', '.')));
// export const isNumeric = (value: any) => /^[-+]?[0-9]*([.,][0-9]+)?$/.test(toSafeString(value))
export const isNumeric = (value) => /^[-+]?(?:[0-9]+([.,][0-9]*)?|[0-9]*[.,][0-9]+)$/.test(toSafeString(value));
export const encodeQueryValue = (value) => toSafeString(value).replaceAll(',', '%2C').trim();
export const decodeQueryValue = (value) => value.toString().replaceAll('%2C', ',').trim();
// export const toCamelCase = (value: string | number | undefined): string => {
//   const str = toSafeString(value)
//   return str.slice(0, 1).toLowerCase() + str.slice(1).replace(/(\s[a-z])/gi, (g1: string) => g1.toUpperCase().trim())
// }
export const roundToPrecision = (value, floatPrecision) => {
    const multiplicand = Math.pow(10, floatPrecision);
    return Math.round(toNumber(value) * multiplicand) / multiplicand;
};
export const multiplicate = (arr) => arr.reduce((product, value) => (product *= toNumber(value)), 1);
export const multiplicateObject = (obj) => multiplicate(Object.values(obj));
/**
 * Adds a proxy to an object to watch for changes
 * @param obj object to watch
 * @param callback callback that runs when a change is detected
 * @param deep whether to watch for changes in nested objects as well
 * @returns
 */
export const watchObj = (obj, callback, deep) => {
    return new Proxy({ value: obj }, {
        get(target, prop) {
            const value = target?.value[prop];
            if (deep && typeof value === 'object' && value !== null) {
                // recursive deep watch
                return watchObj(value, callback, deep);
            }
            return value;
        },
        set(target, prop, newValue) {
            const prevValue = target.value?.[prop];
            if (prevValue !== newValue) {
                callback(newValue, prevValue);
                return true;
            }
            return false;
        },
    });
};
export const getDateString = () => new Date().toISOString().substring(0, 10);
/**
 * Searches for an item in the array, matching the predicate
 * @param array
 * @param predicate search predicate
 * @param customMapper optional custom mapper run on the found result
 * @returns the result of the mapper, or if none given, the result of the predicate
 */
// export const findMap = <T, R>(array: T[] | undefined, predicate: (item: T) => R | undefined, customMapper?: (item: T, index: number) => R) => {
//   if (array) {
//     let index = 0
//     for (const item of array) {
//       const result = predicate(item)
//       if (result !== undefined) {
//         if (customMapper) {
//           return customMapper(item, index)
//         } else {
//           return result
//         }
//       }
//       index++
//     }
//   }
// }
/** Finds an item in the array matching the findMapper and returns the result of the callback */
export const findMap = (array, findMapper) => {
    if (array) {
        for (const item of array) {
            const result = findMapper(item);
            if (result !== undefined) {
                return result;
            }
        }
    }
};
export const valueTypeIsNumeric = (valueType) => valueType === 'int' || valueType === 'float';
export const arrayToRecord = (arr, indexKey, keyFormattingCb = toSafeString) => arr?.reduce((acc, item) => {
    if (item) {
        const key = keyFormattingCb(item[indexKey]);
        acc[key] = item;
    }
    return acc;
}, {});
export const arrayToMap = (arr, indexKey, keyFormattingCb = toSafeString) => arr?.reduce((acc, item) => {
    if (item) {
        const key = keyFormattingCb(item[indexKey]);
        acc.set(key, item);
    }
    return acc;
}, new Map());
export const mapToRecord = (map) => map?.entries().reduce((acc, [key, value]) => {
    if (value) {
        acc[key] = value;
    }
    return acc;
}, {});
export const multiply = (obj) => Object.values(obj || {}).reduce((product, value) => (product *= toNumber(value)), 1);
/**
 * Filters empty values and joins
 */
export const joinArray = (arr, joiner = ', ') => {
    return arr.filter((value) => value || value === 0).join(joiner);
};
export const objectIsEmpty = (obj) => {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
};
// export const getAltLanguageField = (product: BaseProduct | ProductInput | SimplifiedProduct, field: keyof LanguageSpecifics, includedCountries?: Country[]) => {
//   if (includedCountries?.length) {
//     for (const country of includedCountries) {
//       const language = SettingsService.cultureByCountry?.[country]?.language
//       const value = language ? product.languageSpecific?.[language]?.[field] : undefined
//       if (language && value && typeof value !== 'object') {
//         return { value, language }
//       }
//     }
//   } else {
//     const found = Object.entries(product.languageSpecific || {}).find(([language, languageData]) => !!languageData[field])
//     const value = found?.[1]?.[field]
//     return value && typeof value !== 'object' ? { language: found?.[0] as Language, value } : undefined
//   }
// }
/**
 * Starts async tasks concurrently to avoid starting all at once, but also reducing the idle time caused by network latency
 * @param tasks an array of asynchronous callbacks
 * @param maxConcurrentTasks the maximum amount of started tasks at any given time
 * @returns
 */
export const concurrentlyProcessAsyncTasks = async (tasks, maxConcurrentTasks, silenceErrors) => {
    // const results = new Array<T | Error>(tasks.length)
    const results = new Array(tasks.length);
    let nextProcessingIndex = 0;
    const startNextTask = async () => {
        while (nextProcessingIndex < tasks.length) {
            const currentProcessingIndex = nextProcessingIndex++;
            try {
                const result = await tasks[currentProcessingIndex](currentProcessingIndex);
                results[currentProcessingIndex] = result;
            }
            catch (err) {
                console.warn(`task ${currentProcessingIndex} errored`);
                console.warn(err);
                if (!silenceErrors) {
                    throw err;
                }
                // results[nextProcessingIndex] = err as Error
            }
        }
        // when done, the next task will run if there are more to process
    };
    await Promise.all(Array.from({ length: maxConcurrentTasks }, startNextTask)); // start the initial pool of concurrent tasks
    return results;
};
/**
 * Processes items in an array in batches
 * @param items items to be processed
 * @param batchSize the max batch size
 * @param batchCallback the callback function that should process the batch. optionally passes a result array to put in the patch results in that will be returned when all is done
 * @param batchMaxAttempts the maximum number of retries (reset after success)
 * @param retryDelayMs delay after each failed attempt
 * @throws if a batch fails more than batchMaxAttempts times. (attempts resets on success before the next batch)
 * @returns an array of results
 */
export const batchProcess = async (items, batchSize, batchCallback, batchMaxAttempts = 3, retryDelayMs = 5000) => {
    const totalBatches = Math.ceil(items.length / batchSize);
    const results = [];
    let batchAttempts = 0;
    for (let batchIndex = 0; batchIndex < totalBatches;) {
        try {
            const batchItems = items.slice(batchIndex * batchSize, batchIndex * batchSize + batchSize);
            const batchResults = await batchCallback(batchItems, { batchIndex, totalBatches, maxBatchSize: batchSize });
            if (Array.isArray(batchResults)) {
                results.push(...batchResults);
            }
            else {
                results.push(batchResults);
            }
            batchAttempts = 0;
            batchIndex++;
        }
        catch (err) {
            console.warn(err);
            console.warn(`Batch ${batchIndex + 1} failed`);
            if (batchAttempts === batchMaxAttempts) {
                throw new Error(`Batch processing failed on batch ${batchIndex + 1}/${totalBatches} after ${batchMaxAttempts} attempts`);
            }
            console.log(`Re-posting batch in ${retryDelayMs / 1000} seconds`);
            await new Promise((r) => setTimeout(r, retryDelayMs));
            batchAttempts++;
        }
    }
    return results;
};
/**
 * Sets an acceptable span and ensures the return value falls within the span. Returns the value if within the min-max span
 */
export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
/**
 * Splits string on white space, but preserves parts encased in quotation marks
 * @param str
 */
export const splitWords = (str) => Array.from(str.matchAll(/"([^"]+)"|[^\s"]+/g), (m) => m[1] ?? m[0]);
export const getLocaleStringFromCulture = (culture) => `${culture.language?.slice(0, 2)}-${culture.country}`;
export const imgSortFunction = (a, b, sku) => {
    if (a.startsWith(`${sku}.`)) {
        return -1;
    }
    else if (b.startsWith(`${sku}.`)) {
        return 1;
    }
    else {
        return new Intl.Collator('sv', { numeric: true }).compare(a, b);
    }
};
/** Performant join to string of object array */
export const arrayJoin = (array, key) => {
    if (!array) {
        return;
    }
    let result = '';
    for (let i = 0; i < array.length; i++) {
        if (i > 0) {
            result += ', ';
        }
        result += array[i][key];
    }
    return result;
};
/** Performant join to string of object array */
export const arrayMapJoin = (array, mapFunction) => {
    if (!array) {
        return;
    }
    let result = '';
    for (let i = 0; i < array.length; i++) {
        if (i > 0) {
            result += ', ';
        }
        result += mapFunction(array[i]);
    }
    return result;
};
export function* joinIterators(iterable1, iterable2) {
    if (iterable1)
        yield* iterable1;
    if (iterable2)
        yield* iterable2;
}
/** Performant way of conforming an object Iterable to something simpler */
export function* pluckIterator(items, key) {
    for (const item of items) {
        yield item[key];
    }
}
// export const isDevEnv = () => getEnvVar('IS_DEV_ENV') == '1'
// export const isBetaEnv = () => getEnvVar('IS_BETA_ENV') == '1'
export const getImageUrl = (imagePath, size = 2560, source) => {
    if ((!source || source === 'imageLibrary') && imagePath) {
        return `https://imgs.burde.com/media/${size}/${imagePath}`;
    }
    return imagePath || '';
};
